import { useMemo, useSyncExternalStore } from 'react';

export interface ChartColors {
  series: [string, string, string, string, string];
  foreground: string;
  muted: string;
  border: string;
}

const VARS = ['--chart-1', '--chart-2', '--chart-3', '--chart-4', '--chart-5', '--foreground', '--muted-foreground', '--border'];
const SEP = '|';
// Fallbacks only matter if a token is missing; they keep the chart readable rather than invisible.
const FALLBACK = ['#0f766e', '#b45309', '#7c3aed', '#be123c', '#1d4ed8', '#111111', '#666666', '#dddddd'];

function read(): string {
  const cs = getComputedStyle(document.documentElement);
  return VARS.map((v, i) => cs.getPropertyValue(v).trim() || FALLBACK[i]).join(SEP);
}

// next-themes toggles the `dark` class (and style color-scheme) on <html>.
function subscribe(onChange: () => void) {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme', 'style'] });
  return () => observer.disconnect();
}

const serverSnapshot = () => FALLBACK.join(SEP);

/** Resolved chart colours from the CSS tokens; re-reads when the theme on <html> changes. */
export function useChartColors(): ChartColors {
  const snap = useSyncExternalStore(subscribe, read, serverSnapshot);
  return useMemo(() => {
    const p = snap.split(SEP);
    return {
      series: [p[0], p[1], p[2], p[3], p[4]],
      foreground: p[5],
      muted: p[6],
      border: p[7],
    };
  }, [snap]);
}
